/**
 * Configuration for the embedded PageLoop widget on the marketing
 * site. The marketing app uses PageLoop *as a demo of itself* —
 * visitors can highlight any text on pageloop.dev and leave a public
 * comment. The same backend that powers the hosted product hosts
 * the demo project.
 *
 * Values are env-keyed (Vite `import.meta.env.VITE_*`) with safe
 * production defaults baked in so a fresh `pnpm build` produces a
 * working bundle without an .env file. Override locally via
 * `apps/marketing/.env.local`:
 *
 *   VITE_PAGELOOP_ENDPOINT=https://pageloop.dev
 *   VITE_PAGELOOP_PROJECT=marketing-demo
 *
 * The defaults point at the production PageLoop server + a demo
 * project slug that the server admin must create separately (see the
 * "Set up the demo project" section in apps/marketing/README.md).
 */

/** Backend URL the widget talks to. Production = the prod PageLoop server. */
export const PAGELOOP_ENDPOINT: string =
  import.meta.env.VITE_PAGELOOP_ENDPOINT ?? 'https://pageloop.dev';

/**
 * Slug (or id) of the project the widget binds to. Comments + replies
 * land in this project; the cleanup scheduler we wire in next step
 * will sweep this project on whatever cadence the admin sets.
 */
export const PAGELOOP_PROJECT: string =
  import.meta.env.VITE_PAGELOOP_PROJECT ?? 'marketing-demo';

/**
 * Toggle for local development where you don't want a widget loading
 * against a remote backend on every save. Set
 * `VITE_PAGELOOP_DISABLED=1` in `.env.local` and the provider mounts
 * as a no-op passthrough. Production builds always have it on.
 */
export const PAGELOOP_DISABLED: boolean =
  import.meta.env.VITE_PAGELOOP_DISABLED === '1';
